import {
  api, getOptions,
} from './helpers';

const get = (email) => api.post('/staff/get', email, getOptions());

export default {
  get,
};
